'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themer = require('../../../../themer');

var _memoizeClassName = require('../utils/memoizeClassName');

var _memoizeClassName2 = _interopRequireDefault(_memoizeClassName);

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultAppearance = _themer.Themer.createSwitchAppearance({
  base: {
    transition: 'all 120ms ease-in-out',
    cursor: 'pointer',
    color: 'white',
    backgroundColor: _scales2.default.neutral.N5A,
    borderRadius: 9999
  },
  disabled: {
    opacity: 0.5,
    backgroundImage: 'none'
  },
  hover: {
    backgroundColor: _scales2.default.neutral.N5A
  },
  active: {
    backgroundColor: _scales2.default.neutral.N6A
  },
  focus: {
    boxShadow: '0 0 0 3px ' + _scales2.default.primary.P6A
  },
  checked: {
    backgroundColor: _scales2.default.primary.P8,
    color: 'white'
  },
  checkedHover: {
    backgroundColor: _scales2.default.primary.P8,
    color: 'white'
  },
  checkedActive: {
    backgroundColor: _scales2.default.primary.P9,
    color: 'white'
  },
  checkedDisabled: {}
});

/**
 * Get the className of a `Switch`.
 * @param {string} appearance
 * @return {Object} the appearance object.
 */
var getSwitchAppearance = function getSwitchAppearance() {
  return defaultAppearance;
};

/**
 * Get the className of a `Switch`.
 * @param {string} appearance
 * @return {string} the appearance class name.
 */
exports.default = (0, _memoizeClassName2.default)(getSwitchAppearance);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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